import { render, staticRenderFns } from "./approveFbpClaims.vue?vue&type=template&id=0caa0c96&scoped=true"
import script from "./approveFbpClaims.vue?vue&type=script&lang=js"
export * from "./approveFbpClaims.vue?vue&type=script&lang=js"
import style0 from "./approveFbpClaims.vue?vue&type=style&index=0&id=0caa0c96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caa0c96",
  null
  
)

export default component.exports